 export function generateRandomObjectId() {
    return (
      Math.floor(Date.now() / 1000).toString(16) + // 8 characters based on timestamp
      'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
        return (Math.random() * 16 | 0).toString(16); // Random hex values for the rest
      })
    ).toLowerCase();
  }
  